module.exports = __webpack_public_path__ + "static/about-static-a09b682570d1463ad9d17443e3b3c094.png";